<template>
	<div class="sing-in _modal">
		<div class="_modal-overlay" @click.self="$emit('close')"></div>
		<div class="sing-in__inner _modal-inner">
			<div class="sing-in__close _modal-close" @click="$emit('close')"></div>
			<div class="sing-in__content">
				<div class="sing-in__weapon sing-in__weapon_1 _ibg-contain">
					<img src="@/assets/images/bg/login/01.png" />
				</div>
				<div v-if="loginContentVisible" class="sing-in__login">
					<div class="sing-in__title _h2">
						{{ $t('log in to your account') }}
					</div>
					<div class="sing-in__form">
						<button
							class="sing-in__steam _btn-primary"
							@click="redirectToSteamAuth"
						>
							<span class="sing-in__steam-icon _ibg-contain">
								<img src="@/assets/images/icons/steam.png" />
							</span>
							<span>{{ $t('login with steam') }}</span>
						</button>
						<div class="sing-in__label">{{ $t('or ') }}</div>
						<BaseInput
							class="sing-in__input"
							v-model="email"
							type="email"
							autocomplete="email"
							:label="`${$t('Email')}:`"
						/>
						<BaseInput
							class="sing-in__input"
							v-model="pass"
							type="password"
							:label="`${$t('Password')}:`"
						/>
						<div class="sing-in__bottom">
							<button
								class="sing-in__link _link-primary"
								@click="switchToforgotPass"
							>
								{{ $t('Forgot password?') }}
							</button>
						</div>
						<Transition>
							<div v-if="error" class="sing-in__error">
								{{ error }}
							</div>
						</Transition>
						<button
							@click="submitLogin"
							:disabled="loaderIsVisible || email === '' || pass === ''"
							class="sing-in__submit _btn-primary"
						>
							<span v-if="loaderIsVisible"
								>{{ $t('Logging in') }}...</span
							>
							<span v-else>{{ $t('Log in') }}</span>
						</button>
					</div>
				</div>
				<div v-if="forgotPassContentVisible" class="sing-in__forgot">
					<div class="sing-in__title _h2">
						{{ $t('Recover your password') }}
					</div>
					<div class="sing-in__form">
						<BaseInput
							class="sing-in__input sing-in__input_forgot"
							v-model="email"
							type="email"
							autocomplete="username"
							:label="`${$t('Email')}:`"
						/>
						<div class="sing-in__bottom">
							<p class="sing-in__text">
								{{ $t('Remember your password?') }}
							</p>
							<button
								class="sing-in__link _link-primary"
								@click="switchToLogin"
							>
								{{ $t('Log in') }}
							</button>
						</div>
						<Transition>
							<div v-if="successMessage" class="sing-in__success">
								{{ successMessage }}
							</div>
						</Transition>
						<Transition>
							<div v-if="error" class="sing-in__error">{{ error }}</div>
						</Transition>
						<button
							@click="submitForgotPass"
							:disabled="loaderIsVisible || email === ''"
							class="sing-in__submit _btn-primary"
						>
							<span v-if="loaderIsVisible"
								>{{ $t('Recovering') }}...</span
							>
							<span v-else>{{ $t('Recover') }}</span>
						</button>
					</div>
				</div>
				<div class="sing-in__weapon sing-in__weapon_2 _ibg-contain">
					<img src="@/assets/images/bg/login/02.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput.vue';

export default {
	name: 'SigninPage',
	components: { BaseInput },
	props: {
		isAuth: { type: Boolean, required: true },
		isLoginModalVisible: { type: Boolean, required: true },
		error: {
			type: String,
			default: '',
			required: true,
		},
		loaderIsVisible: {
			type: Boolean,
			required: true,
		},
		successMessage: {
			type: String,
			required: true,
		},
		showResendOption: {
			type: Boolean,
			required: true,
		},
	},
	data: function () {
		return {
			loginContentVisible: true,
			forgotPassContentVisible: false,
			email: '',
			pass: '',
		};
	},
	watch: {
		isAuth(isNowAuthed) {
			if (
				isNowAuthed &&
				this.$route.path !== '/profile/personal-information'
			) {
				this.$router.push('/profile/personal-information');
			}
		},
	},
	mounted() {},
	methods: {
		redirectToSteamAuth() {
			window.location.href = `${process.env.VUE_APP_DOMAIN}auth/steam/redirect`;
		},
		resendVerificationEmail() {
			this.$emit('resendVerificationEmail', this.email);
		},
		openSignUp() {
			this.$emit('clearError');
			this.$emit('openSignUp');
		},
		switchToforgotPass() {
			this.$emit('hideResendOption');
			this.$emit('clearError');
			setTimeout(() => {
				this.loginContentVisible = false;
				this.forgotPassContentVisible = true;
			}, 100);
		},
		switchToLogin() {
			this.$emit('hideResendOption');
			this.$emit('clearError');
			setTimeout(() => {
				this.forgotPassContentVisible = false;
				this.loginContentVisible = true;
			}, 100);
		},
		submitLogin() {
			let loginData = {
				username: this.email,
				password: this.pass,
			};
			this.$emit('login', loginData);
		},
		submitForgotPass() {
			let data = {
				email: this.email,
			};
			this.$emit('forgotPass', data);
			this.email = '';
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.sing-in {
	&__inner {
		@include adaptiveValue('padding-top', 60, 40);
		@media (min-width: $md2) and (min-height: 619.98px) {
			max-height: 100%;
			overflow: hidden;
			padding-left: 70px;
			padding-right: 70px;
			max-width: 1100px;
			background-color: transparent;
		}
		@media (max-width: $md2) {
			overflow-x: hidden;
		}
		@media (max-height: 619.98px) {
			max-width: 800px;
			overflow-x: hidden;
		}
	}
	&__close {
		@media (min-width: $md2) and (min-height: 619.98px) {
			right: 85px;
		}
	}
	&__content {
		min-height: 100%;
		position: relative;
		display: flex;
		gap: 20px;
		min-height: 0;
		@media (min-width: $md3) and (min-height: 619.98px) {
			position: relative;
			&::before {
				z-index: -1;
				content: '';
				position: absolute;
				@include adaptiveValue('top', -60, -25);
				left: 0px;
				@include adaptiveValue('height', 60, 25);
				width: 100%;
				background: #080b0c;
				border-top-left-radius: var(--border-radius-primary);
				border-top-right-radius: var(--border-radius-primary);
				overflow: hidden;
			}
		}
	}
	&__login,
	&__forgot {
		flex: 1 1 100%;
		background: #080b0c;

		@media (min-width: $md3) and (min-height: 619.98px) {
			@include adaptiveValue('padding-bottom', 60, 25);
			border-bottom-left-radius: var(--border-radius-primary);
			border-bottom-right-radius: var(--border-radius-primary);
			min-height: 600px;
		}
		@media (max-width: $md3) {
			border-radius: var(--border-radius-primary);
		}
		@media (max-height: 619.98px) {
			border-radius: var(--border-radius-primary);
		}
	}
	&__weapon {
		position: absolute;
		max-width: 330px;
		@include adaptiveValue('max-width', 330, 230, 1470, 992, 1);
		width: 100%;
		padding-bottom: 30%;
		align-self: center;
		transform: translate(0px, -50%);
		&_1 {
			left: -10%;
			top: 50%;
		}
		&_2 {
			right: -10%;
			top: 80%;
		}
		@media (max-width: $md3) {
			@include hide-item;
		}
		@media (max-height: 619.98px) {
			@include hide-item;
		}
	}
	&__forgot {
		display: flex;
		flex-direction: column;
		.sing-in__form {
			margin: auto;
		}
	}
	&__title {
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__steam {
		display: flex;
		align-items: center;
		gap: 8px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
		span {
			position: relative;
			z-index: 1;
		}
		&::before {
			z-index: 0;
		}
		&-icon {
			min-width: 20px;
			height: 20px;
		}
	}
	&__label {
		color: var(--secondary-color);
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__form {
		width: 100%;
		max-width: 386px;
		margin: 0 auto;
	}
	&__input {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 16, 10);
		}
		&_forgot {
		}
	}
	&__bottom {
		display: flex;
		gap: 6px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
	}
	&__link {
	}
	&__text {
		color: var(--primary-color);
		font-weight: 500;
		font-size: 16px;
	}
	&__link-up {
	}
	&__error,
	&__success {
		font-family: var(--font-family-inter);
		font-size: 16px;
		line-height: 120%;
		font-weight: 500;
		display: block;
		text-align: center;
		margin-bottom: 8px;
	}
	&__error {
		color: var(--error-color);
	}
	&__success {
		color: var(--success-color);
	}
	&__submit {
		min-width: 125px;
		margin: 0 auto;
		span {
			position: relative;
			z-index: 1;
		}
		&::before {
			z-index: 0;
		}
	}
}
</style>
